import ControlUserRolePage from "./ControlUserRolePage";

export default ControlUserRolePage;
